import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=82883562&scoped=true&lang=html&"
import script from "./ActivitySummary.vue?vue&type=script&lang=ts&"
export * from "./ActivitySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82883562",
  null
  
)

export default component.exports